import './NotSetIndicator.less';
import React from 'react';


export default function NotSetIndicator() {

    return <span className="not-set-indicator">-</span>;
}
